<script>
export default {
  name: 'LoginFormLoginMethod',
  props: {
    value: {
      type: String,
      default: 'email',
    },
  },
  emits: ['update:value'],
  methods: {
    onClickPhoneNumberTab() {
      this.$emit('update:value', 'phoneNumber')

      this.$emit('click:phone-numer-tab')
    },
  },
}
</script>

<template>
  <div class="tamara-login-method-action">
    <div
      class="tamara-login-method-action__content"
      :class="{
        'selected-email': value === 'email',
        'selected-phone-number': value === 'phoneNumber',
      }"
    >
      <div
        class="tamara-login-method-action__item"
        @click="$emit('update:value', 'email')"
      >
        {{ $t('login_email_tab_name_label') }}
      </div>
      <div
        class="tamara-login-method-action__item"
        @click="onClickPhoneNumberTab"
      >
        {{ $t('login_phone_number_tab_name_label') }}
      </div>
      <div class="tamara-login-method-action__item__bg" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
@import '@/styles/lavender/design.scss';

.tamara-login-method-action {
  --tamara-selected-email-highlight: 0;
  --tamara-selected-phone-number-highlight: 100%;

  @extend .tamara-flex-center;

  height: 56px;
  padding: var(--tamara-spacing-2xs);
  background-color: var(--tamara-background-color-secondary);
  border-radius: var(--tamara-border-radius-full);

  &__content {
    @extend .tamara-flex-center;

    position: relative;
    width: 100%;
    height: 100%;
    background-color: transparent;

    .tamara-login-method-action__item__bg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 50%;
      background-color: var(--tamara-background-color-primary);
      border-radius: var(--tamara-border-radius-full);
    }

    &.selected-email {
      .tamara-login-method-action__item__bg {
        transition: transform 300ms ease-out;
        transform: translateX(var(--tamara-selected-email-highlight));
      }
    }

    &.selected-phone-number {
      .tamara-login-method-action__item__bg {
        transition: transform 300ms ease-out;
        transform: translateX(var(--tamara-selected-phone-number-highlight));
      }
    }
  }

  &__item {
    @extend .tamara-flex-center;
    @extend .tamara-label-medium;

    z-index: 10;
    flex: 1 1 50%;
    max-width: 50%;
    cursor: pointer;
  }
}

@include for-rtl {
  .tamara-login-method-action {
    --tamara-selected-email-highlight: 100%;
    --tamara-selected-phone-number-highlight: 0;
  }
}
</style>
